import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const SearchTermSuggestionsLoading = () => {
  const simplePlaceholders = (
    <div>
      <p className="bg-color-grey text-size-body-sm px-2 py-1">
        <Skeleton className="my-0.5 h-1.5 w-[30%]" />
      </p>
      <div className="flex flex-col gap-1 py-0.5 pl-2">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={`loading-skeleton-${index}`}
            className="my-0.5 h-1.5 w-[40%]"
          />
        ))}
      </div>
    </div>
  );

  return (
    <div className="grid max-h-[50vh] overflow-y-auto sm:grid-cols-1 sm:overflow-y-scroll lg:grid-cols-2">
      <div className="flex flex-col gap-1 sm:grid-cols-1">
        {simplePlaceholders}
        {simplePlaceholders}
      </div>
      <div className="border-l-color-grey sm:grid-cols-1 lg:border-l-1 lg:first:border-l-0">
        <div>
          <p className="bg-color-grey text-size-body-sm px-2 py-1">
            <Skeleton className="my-0.5 h-1.5 w-[30%]" />
          </p>
          {Array.from({ length: 3 }).map((_1, i) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <div key={i} className="flex gap-1 px-2 py-0.5">
              <Skeleton className="h-[5rem] w-[4rem] rounded-none" />

              <div className="flex-1">
                {Array.from({ length: 3 }).map((_2, j) => (
                  // eslint-disable-next-line @eslint-react/no-array-index-key
                  <Skeleton key={j} className="my-1 h-1.5 w-[80%]" />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
